module.exports = function surround(str, wrapper) {
  return [wrapper, str, wrapper].join('');
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/surround.js
 ** module id = 451
 ** module chunks = 0
 **/